import icon from './ВКО_Алтай,_Катон_Карагай,_Курчумский_районы.svg'

export default [
  icon
]
